import { Component } from '@angular/core';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { Title, Meta } from '@angular/platform-browser';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle('Contact Us | World2Cover Australia');
    this.metaService.updateTag({
      name: 'description',
      content: `Contact our travel insurance experts for quotes, policy updates or claims. Get 24/7 emergency assistance and find a plan that suits you.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Contact Us | World2Cover Australia',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Contact our travel insurance experts for quotes, policy updates or claims. Get 24/7 emergency assistance and find a plan that suits you.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
